module.exports = __webpack_public_path__ + "media/images/gallery/3s-fe8028ad8bea86aeb0e15fb1cf4c33ad.jpg";